const url_wn = `${process.env.VUE_APP_WN}/`;

export const get_online_monitoring = async ({
    organisation,
    date
}) => {
  const url = new URL('fact/monitoring/summary', url_wn);

  const res = await window.ky_wn.post(url, {
    json: {
      organisation_id: organisation,
      date,
    }
  }).json();

  if (!res.success) return res;

  const { platforms, containers, volumes, stat } = res.data;

  return {
    success: true,
    data: {
      platforms,
      containers,
      volume: volumes,
      vehicles: stat?.fact_vehicles ?? 0,
      wos: {
        count: (stat?.success_workorders ?? 0) + (stat?.progress_workorders ?? 0),
        vehicles: stat?.fact_vehicles ?? 0,
      },
      workorders: {
        progress: stat?.progress_workorders ?? 0,
        success: stat?.success_workorders ?? 0,
      },
    }
  };
}

export const get_events_counter_list =
  async ({
      organisation: o,
      date,
      page: page = 'all',
      waste_type_ids: waste_type_ids = [],
  }) => {
    //Ожидает из параметров query
    //key: о с id организации 
    //key: date для фильтрации по выбранному дню
    //key: page = 'all' дефолтное все страницы 
    //key: waste_type_ids = [] массив с id типа контейнерной площадки
    const url = new URL('fact/summary/counter_list', url_wn);

    return await window.ky_wn.post(url, {
      json: {
        o,
        date,
        page,
        waste_type_ids,
      }
    }).json();
  }

export const get_vehicle_statistic = async ({
  vehicle_id,
  date,
}) => {
  //Ожидает из параметров query
  //key: vehicle_id с id машины 
  //key: date для фильтрации по выбранному дню
  const url = new URL(`fact/vehicle/stats/${vehicle_id}`, url_wn);
  url.searchParams.set('begin_date', date)
  url.searchParams.set('end_date', date)

  return await window.ky_wn.get(url).json();
}